import type { NavigateFunction } from 'react-router-dom';
import { isNativeApp } from './platform';

function pathFromUrl(raw: string): string | null {
  try {
    const url = new URL(raw);
    if (url.protocol === 'peakperformanceiq:') {
      const path = `/${[url.hostname, url.pathname.replace(/^\//, '')].filter(Boolean).join('/')}`.replace(/\/+/g, '/');
      return path.length > 1 ? path : null;
    }
    if (url.hostname === 'peakperformanceiq.com' || url.hostname === 'www.peakperformanceiq.com') {
      return `${url.pathname}${url.search}`;
    }
  } catch {
    if (raw.startsWith('/')) return raw;
  }
  return null;
}

export function initDeepLinks(navigate: NavigateFunction): () => void {
  if (!isNativeApp()) return () => undefined;

  let cancelled = false;
  const cleanups: Array<() => void> = [];

  void (async () => {
    try {
      const { App } = await import('@capacitor/app');
      if (cancelled) return;

      const sub = await App.addListener('appUrlOpen', ({ url }) => {
        const path = pathFromUrl(url);
        if (path) navigate(path, { replace: false });
      });
      cleanups.push(() => void sub.remove());

      const launch = await App.getLaunchUrl();
      if (launch?.url) {
        const path = pathFromUrl(launch.url);
        if (path) navigate(path, { replace: true });
      }
    } catch {
      /* ignore */
    }
  })();

  return () => {
    cancelled = true;
    for (const fn of cleanups) fn();
  };
}
